// Step 1: Create a WindowContext.tsx file
import React, { createContext, useContext, useState, useEffect } from 'react';

interface WindowContextType {
  windowWidth: number;
  windowHeight: number;
  isMobile: boolean;
}

const WindowContext = createContext<WindowContextType | undefined>(undefined);

export const WindowProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [windowDimensions, setWindowDimensions] = useState<WindowContextType>({
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    isMobile: window.innerWidth < 420 // Adjust breakpoint as needed
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        isMobile: window.innerWidth < 420
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <WindowContext.Provider value={windowDimensions}>
      {children}
    </WindowContext.Provider>
  );
};

// Step 2: Create a custom hook to use this context
export const useWindow = (): WindowContextType => {
  const context = useContext(WindowContext);
  if (context === undefined) {
    throw new Error('useWindow must be used within a WindowProvider');
  }
  return context;
};